<template>
  <b-navbar
    toggleable="xl"
    fixed="top"
    v-b-scrollspy:nav-scroller
    class="header-area text-white"
    :class="{ 'is-sticky': scrolled }"
  >
    <div class="container-fluid container-fluid--cp-150">
      <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
      <b-navbar-brand class="navbar-brand logo-light" href="/#home">
        <img src="../assets/img/logo/logo-light.png" alt="logo" />
      </b-navbar-brand>
      <b-navbar-brand class="navbar-brand logo-dark" href="/#home">
        <img src="../assets/img/logo/logo-dark.png" alt="logo" />
      </b-navbar-brand>
      <b-collapse class="default-nav justify-content-center" is-nav id="nav_collapse">
        <b-navbar-nav class="navbar-nav main-menu text-white">
          <b-nav-item href="/#home" class="scroll"><span>HOME</span></b-nav-item>
          <b-nav-item href="/#about" class="scroll"><span>ABOUT</span></b-nav-item>
          <b-nav-item href="/#projects" class="scroll"><span>PROJECTS</span></b-nav-item>
          <b-nav-item href="/#pxl" class="scroll"><span>$PXL</span></b-nav-item>
          <b-nav-item href="/#contact" class="scroll"><span>CONTACT</span></b-nav-item>
          <b-btn-group class="header-button button--white d-xl-none">
            <router-link v-if="this.user === null" to="/login" class="btn btn--white"
              >Log In or Create Pixel Profile</router-link
            >
            <router-link v-if="this.user != null" to="/profile" class="btn btn--white mr-2"
              >Profile</router-link
            >
            <router-link
              v-if="this.user != null"
              active-class=""
              to="/"
              class="btn btn--white"
              @click.native="logout"
            >
              Log Out
            </router-link>
            >
          </b-btn-group>
        </b-navbar-nav>
      </b-collapse>
      <div class="header-button button--white d-none d-xl-block">
        <router-link v-if="this.user === null" to="/login" class="btn btn--white"
          >Log In or Create Pixel Profile</router-link
        >
        <router-link v-if="this.user != null" to="/profile" class="btn btn--white mr-2"
          >Profile</router-link
        >
        <router-link
          v-if="this.user != null"
          active-class=""
          to="/"
          class="btn btn--white"
          @click.native="logout"
        >
          Log Out
        </router-link>
        <b-link class="mobile-menu-bar d-xl-none" @click="mobiletoggleClass('addClass', 'active')">
          <i class="fa fa-bars"></i
        ></b-link>
      </div>

      <!-- if they are logged in
            <b-btn-group class="header-button button--white d-none d-xl-block">
                <b-link class="btn btn--white">Manage your Pixel Profile</b-link>
            </b-btn-group> -->
    </div>
  </b-navbar>
</template>

<script>
export default {
  name: 'Navbar',
  data() {
    return {
      load: false,
      limitPosition: 200,
      scrolled: false,
      lastPosition: 500,
    }
  },
  methods: {
    // sticky menu script
    handleScroll() {
      if (this.lastPosition < window.scrollY && this.limitPosition < window.scrollY) {
        this.scrolled = true
        // move up!
      }

      if (this.lastPosition > window.scrollY) {
        this.scrolled = true
        // move down
      }

      this.lastPosition = window.scrollY
      this.scrolled = window.scrollY > 50
    },
    logout: function () {
      this.$store.commit('clearSession')
      this.$store.commit('clearWallet')
      this.$router.push('/')
    },
  },
  created() {
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  computed: {
    user() {
      return this.$store.getters.user
    },
  },
}
</script>
